module.exports = __webpack_public_path__ + "ddbbfef981adaa294ad3768697381ba6.svg";